import { Link } from "react-router-dom";
import customIcon from "@/assets/icon.jpg";

const Footer = () => {
  return (
    <footer className="relative border-t border-border/50 mt-auto overflow-hidden">
      {/* Subtle Particles Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-primary/20 rounded-full floating-particle"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${8 + Math.random() * 4}s`,
            }}
          />
        ))}
      </div>

      <div className="relative container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2 space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-xl glass-card flex items-center justify-center">
                <img src={customIcon} alt="FactScan AI" className="w-5 h-5" />
              </div>
              <span className="text-xl font-bold gradient-text">FactScan AI</span>
            </div>
            <p className="text-muted-foreground text-sm max-w-md leading-relaxed">
              Transform documents into insights with AI-powered OCR. Extract text, get summaries, and unlock the potential of your documents.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-semibold mb-4 text-foreground">Product</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/scan" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Scan
                </Link>
              </li>
              <li>
                <Link to="/no-signup-ocr" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  No-Signup OCR
                </Link>
              </li>
              <li>
                <Link to="/ocr-online" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  OCR Online
                </Link>
              </li>
              <li>
                <Link to="/pdf-to-text-ocr" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  PDF to Text
                </Link>
              </li>
              <li>
                <Link to="/extract-text-from-image" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Image to Text
                </Link>
              </li>
              <li>
                <Link to="/pdf-to-text-converter" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  PDF Converter
                </Link>
              </li>
              <li>
                <Link to="/ai-document-summarizer" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  AI Summarizer
                </Link>
              </li>
              <li>
                <Link to="/use-cases" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Use Cases
                </Link>
              </li>
              <li>
                <Link to="/tools" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  All Tools
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/history" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  History
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold mb-4 text-foreground">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Terms
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border/50 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} FactScan AI. All rights reserved.
          </p>
          <div className="flex gap-8">
            <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Twitter
            </a>
            <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              GitHub
            </a>
            <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
